export default __webpack_public_path__ + "static/media/groupWhite.27f6b0b9.png";